export const skinCareProblem = [
  { id: 1, name: '補濕' },
  { id: 2, name: '平衡油脂' },
  { id: 3, name: '痘痘／暗瘡護理' },
  { id: 4, name: '膚色暗沈' },
  { id: 5, name: '眼周護理' },
  { id: 6, name: '暗瘡印／色素印' },
  { id: 7, name: '突發敏感' },
  { id: 8, name: '毛孔粗大' },
  { id: 9, name: '膚肌鬆弛' },
];

export const skinType = [
  {
    id: 1,
    name: '中性肌',
    desc: '沒有感到泛油/乾燥',
    icon: '/svgs/skin_type/neutral.png',
  },
  {
    id: 2,
    name: '油性肌',
    desc: '全面都泛油',
    icon: '/svgs/skin_type/oil.png',
  },
  {
    id: 3,
    name: '乾燥肌',
    desc: '全面都乾燥',
    icon: '/svgs/skin_type/dry.png',
  },
  {
    id: 4,
    name: '混合偏油',
    desc: 'T字部分泛油 兩頰乾燥',
    icon: '/svgs/skin_type/mix-oil.png',
  },
  {
    id: 5,
    name: '混合偏乾',
    desc: 'T字部分中性 兩頰乾燥',
    icon: '/svgs/skin_type/mix-dry.png',
  },
  {
    id: 6,
    name: '敏感肌',
    desc: '容易泛紅',
    icon: '/svgs/skin_type/sensitive.png',
  },
];

export const considerFactor = [
  { id: 1, name: '價錢' },
  { id: 2, name: '產地' },
  { id: 3, name: '朋友推介' },
  { id: 4, name: '媒體推介' },
  { id: 5, name: '成份' },
  { id: 6, name: '包裝' },
  { id: 7, name: '氣味' },
  { id: 8, name: '方便購買' },
  { id: 9, name: '可持續發展' },
];

export const ageRange = [
  { id: 1, name: '18歲以下' },
  { id: 2, name: '18-24' },
  { id: 3, name: '25-34' },
  { id: 4, name: '35-44' },
  { id: 5, name: '45-54' },
  { id: 6, name: '55或以上' },
];

export const priceRange = [
  { id: 1, name: '$200 以下' },
  { id: 2, name: '$200 至 $400' },
  { id: 3, name: '$400 至 $800' },
  { id: 4, name: '$800 以上' },
  { id: 5, name: '沒有特定要求' },
];

export const locationPreference = [
  { id: 1, name: '日本' },
  { id: 2, name: '韓國' },
  { id: 3, name: '台灣' },
  { id: 4, name: '香港' },
  { id: 5, name: '歐美' },
  { id: 6, name: '沒有特定要求' },
];

export const specialConsiderations = [
  { id: 1, name: '純素' },
  { id: 2, name: '無動物測試' },
  { id: 3, name: '有機' },
  { id: 4, name: 'Clean beauty' },
  { id: 5, name: '孕婦可用' },
  { id: 6, name: '以上都不太會考慮' },
];

export const scalpType = [
  { id: 1, name: '乾性頭皮' },
  { id: 2, name: '油性頭皮' },
  { id: 3, name: '中性頭皮' },
];

export const hairType = [
  { id: 1, name: '幼軟' },
  { id: 2, name: '粗硬' },
  { id: 3, name: '附帶受損髮質' },
];

export const currentCountryList = [
  {
    country: '香港特別行政區',
    countryCode: 'HK',
    email: 'opt-out',
    id: 'country-hong-kong',
  },
  { country: '台灣', countryCode: 'TW', email: 'opt-in', id: 'country-taiwan' },
  {
    country: '英國',
    countryCode: 'GB',
    email: 'opt-in',
    id: 'country-united-kingdom',
  },
  {
    country: '阿富汗',
    countryCode: 'AF',
    email: 'opt-out',
    id: 'country-afghanistan',
  },
  {
    country: '奧蘭群島',
    countryCode: 'AX',
    email: 'opt-out',
    id: 'country-aland-islands',
  },
  {
    country: '阿爾巴尼亞',
    countryCode: 'AL',
    email: 'opt-in',
    id: 'country-albania',
  },
  {
    country: '阿爾及利亞',
    countryCode: 'DZ',
    email: 'opt-out',
    id: 'country-algeria',
  },
  {
    country: '美屬薩摩亞',
    countryCode: 'AS',
    email: 'opt-out',
    id: 'country-american-samoa',
  },
  {
    country: '安道爾',
    countryCode: 'AD',
    email: 'opt-out',
    id: 'country-andorra',
  },
  {
    country: '安哥拉',
    countryCode: 'AO',
    email: 'opt-in',
    id: 'country-angola',
  },
  {
    country: '阿根廷',
    countryCode: 'AR',
    email: 'opt-in',
    id: 'country-argentina',
  },
  {
    country: '亞美利亞',
    countryCode: 'AM',
    email: 'opt-in',
    id: 'country-armenia',
  },
  {
    country: '阿魯巴',
    countryCode: 'AW',
    email: 'opt-out',
    id: 'country-aruba',
  },
  {
    country: '澳洲',
    countryCode: 'AU',
    email: 'opt-in',
    id: 'country-australia',
  },
  {
    country: '奧地利',
    countryCode: 'AT',
    email: 'opt-in',
    id: 'country-austria',
  },
  {
    country: '亞塞拜疆',
    countryCode: 'AZ',
    email: 'opt-in',
    id: 'country-azerbaijan',
  },
  {
    country: '巴哈馬',
    countryCode: 'BS',
    email: 'opt-out',
    id: 'country-bahamas',
  },
  {
    country: '巴林',
    countryCode: 'BH',
    email: 'notice',
    id: 'country-bahrain',
  },
  {
    country: '孟加拉',
    countryCode: 'BD',
    email: 'opt-out',
    id: 'country-bangladesh',
  },
  {
    country: '巴巴多斯',
    countryCode: 'BB',
    email: 'opt-out',
    id: 'country-barbados',
  },
  {
    country: '白俄羅斯',
    countryCode: 'BY',
    email: 'opt-in',
    id: 'country-belarus',
  },
  {
    country: '比利時',
    countryCode: 'BE',
    email: 'opt-in',
    id: 'country-belgium',
  },
  {
    country: '伯利茲',
    countryCode: 'BZ',
    email: 'opt-out',
    id: 'country-belize',
  },
  { country: '貝寧', countryCode: 'BJ', email: 'opt-in', id: 'country-benin' },
  {
    country: '百慕達',
    countryCode: 'BM',
    email: 'opt-out',
    id: 'country-bermuda',
  },
  {
    country: '不丹',
    countryCode: 'BT',
    email: 'opt-out',
    id: 'country-bhutan',
  },
  {
    country: '玻利維亞',
    countryCode: 'BO',
    email: 'notice',
    id: 'country-bolivia',
  },
  {
    country: '波奈',
    countryCode: 'BQ',
    email: 'opt-out',
    id: 'country-bonaire',
  },
  {
    country: '波斯尼亞和黑塞哥維那',
    countryCode: 'BA',
    email: 'opt-in',
    id: 'country-bosnia-and-herzegovina',
  },
  {
    country: '博茨瓦納',
    countryCode: 'BW',
    email: 'notice',
    id: 'country-botswana',
  },
  { country: '巴西', countryCode: 'BR', email: 'notice', id: 'country-brazil' },
  {
    country: '英屬印度洋地區',
    countryCode: 'IO',
    email: 'opt-out',
    id: 'country-british-indian-ocean-territory',
  },
  {
    country: '英屬維爾京群島',
    countryCode: 'VG',
    email: 'opt-out',
    id: 'country-british-virgin-islands',
  },
  {
    country: '文萊',
    countryCode: 'BN',
    email: 'opt-out',
    id: 'country-brunei',
  },
  {
    country: '保加利亞',
    countryCode: 'BG',
    email: 'opt-in',
    id: 'country-bulgaria',
  },
  {
    country: '布基納法索',
    countryCode: 'BF',
    email: 'opt-in',
    id: 'country-burkina-faso',
  },
  {
    country: '布隆迪',
    countryCode: 'BI',
    email: 'notice',
    id: 'country-burundi',
  },
  {
    country: '維德角',
    countryCode: 'CV',
    email: 'opt-in',
    id: 'country-cabo-verde',
  },
  {
    country: '柬埔寨',
    countryCode: 'KH',
    email: 'opt-out',
    id: 'country-cambodia',
  },
  {
    country: '喀麥隆',
    countryCode: 'CM',
    email: 'notice',
    id: 'country-cameroon',
  },
  {
    country: '加拿大',
    countryCode: 'CA',
    email: 'opt-in',
    id: 'country-canada',
  },
  {
    country: '中非共和國',
    countryCode: 'CF',
    email: 'notice',
    id: 'country-central-african-republic',
  },
  { country: '乍得', countryCode: 'TD', email: 'notice', id: 'country-chad' },
  { country: '智利', countryCode: 'CL', email: 'opt-out', id: 'country-chile' },
  { country: '中國', countryCode: 'CN', email: 'opt-in', id: 'country-china' },
  {
    country: '聖誕島',
    countryCode: 'CX',
    email: 'opt-out',
    id: 'country-christmas-island',
  },
  {
    country: '科科斯 (基林) 群島',
    countryCode: 'CC',
    email: 'opt-out',
    id: 'country-cocos-islands',
  },
  {
    country: '哥倫比亞',
    countryCode: 'CO',
    email: 'opt-in',
    id: 'country-colombia',
  },
  {
    country: '科摩羅',
    countryCode: 'KM',
    email: 'opt-out',
    id: 'country-comoros',
  },
  {
    country: '庫克群島',
    countryCode: 'CK',
    email: 'opt-out',
    id: 'country-cook-islands',
  },
  {
    country: '哥斯達黎加',
    countryCode: 'CR',
    email: 'opt-in',
    id: 'country-costa-rica',
  },
  {
    country: '科特迪瓦',
    countryCode: 'CI',
    email: 'notice',
    id: 'country-cote-divoire',
  },
  {
    country: '克羅地亞',
    countryCode: 'HR',
    email: 'opt-in',
    id: 'country-croatia',
  },
  { country: '古巴', countryCode: 'CU', email: 'opt-out', id: 'country-cuba' },
  {
    country: '庫拉索島',
    countryCode: 'CW',
    email: 'opt-out',
    id: 'country-curacao',
  },
  {
    country: '塞浦路斯',
    countryCode: 'CY',
    email: 'opt-in',
    id: 'country-cyprus',
  },
  {
    country: '捷克',
    countryCode: 'CZ',
    email: 'opt-out',
    id: 'country-czechia',
  },
  {
    country: '剛果民主共和國',
    countryCode: 'CD',
    email: 'notice',
    id: 'country-democratic-republic-of-the-congo',
  },
  {
    country: '丹麥',
    countryCode: 'DK',
    email: 'opt-in',
    id: 'country-denmark',
  },
  {
    country: '吉布提',
    countryCode: 'DJ',
    email: 'opt-out',
    id: 'country-djibouti',
  },
  {
    country: '多米尼加',
    countryCode: 'DM',
    email: 'opt-out',
    id: 'country-dominica',
  },
  {
    country: '多米尼加共和國',
    countryCode: 'DO',
    email: 'notice',
    id: 'country-dominican-republic',
  },
  {
    country: '厄瓜多爾',
    countryCode: 'EC',
    email: 'notice',
    id: 'country-ecuador',
  },
  { country: '埃及', countryCode: 'EG', email: 'opt-out', id: 'country-egypt' },
  {
    country: '薩爾瓦多',
    countryCode: 'SV',
    email: 'notice',
    id: 'country-el-salvador',
  },
  {
    country: '赤道幾內亞',
    countryCode: 'GQ',
    email: 'notice',
    id: 'country-equatorial-guinea',
  },
  {
    country: '厄立特里亞',
    countryCode: 'ER',
    email: 'notice',
    id: 'country-eritrea',
  },
  {
    country: '愛沙尼亞',
    countryCode: 'EE',
    email: 'opt-in',
    id: 'country-estonia',
  },
  {
    country: '斯威士蘭',
    countryCode: 'SZ',
    email: 'opt-out',
    id: 'country-eswatini',
  },
  {
    country: '埃塞俄比亞',
    countryCode: 'ET',
    email: 'opt-out',
    id: 'country-ethiopia',
  },
  {
    country: '福克蘭群島',
    countryCode: 'FK',
    email: 'opt-out',
    id: 'country-falkland-islands',
  },
  {
    country: '法羅群島',
    countryCode: 'FO',
    email: 'opt-out',
    id: 'country-faroe-islands',
  },
  { country: '斐濟', countryCode: 'FJ', email: 'opt-out', id: 'country-fiji' },
  {
    country: '芬蘭',
    countryCode: 'FI',
    email: 'opt-in',
    id: 'country-finland',
  },
  { country: '法國', countryCode: 'FR', email: 'opt-in', id: 'country-france' },
  {
    country: '法屬圭亞那',
    countryCode: 'GF',
    email: 'opt-out',
    id: 'country-french-guiana',
  },
  {
    country: '法屬波利尼西亞',
    countryCode: 'PF',
    email: 'opt-out',
    id: 'country-french-polynesia',
  },
  { country: '加蓬', countryCode: 'GA', email: 'notice', id: 'country-gabon' },
  {
    country: '岡比亞',
    countryCode: 'GM',
    email: 'notice',
    id: 'country-gambia',
  },
  {
    country: '格魯吉亞',
    countryCode: 'GE',
    email: 'opt-in',
    id: 'country-georgia',
  },
  {
    country: '德國',
    countryCode: 'DE',
    email: 'double-opt-in',
    id: 'country-germany',
  },
  { country: '加納', countryCode: 'GH', email: 'opt-in', id: 'country-ghana' },
  {
    country: '希臘',
    countryCode: 'GR',
    email: 'double-opt-in',
    id: 'country-greece',
  },
  {
    country: '格陵蘭',
    countryCode: 'GL',
    email: 'opt-out',
    id: 'country-greenland',
  },
  {
    country: '格林納達',
    countryCode: 'GD',
    email: 'opt-out',
    id: 'country-grenada',
  },
  {
    country: '危地馬拉',
    countryCode: 'GT',
    email: 'opt-out',
    id: 'country-guatemala',
  },
  {
    country: '幾內亞',
    countryCode: 'GN',
    email: 'notice',
    id: 'country-guinea',
  },
  {
    country: '幾內亞比紹',
    countryCode: 'GW',
    email: 'opt-out',
    id: 'country-guinea-bissau',
  },
  {
    country: '圭亞那',
    countryCode: 'GY',
    email: 'opt-out',
    id: 'country-guyana',
  },
  { country: '海地', countryCode: 'HT', email: 'opt-out', id: 'country-haiti' },
  {
    country: '赫德島與麥當勞群島',
    countryCode: 'HM',
    email: 'opt-out',
    id: 'country-heard-island-and-mcdonald-islands',
  },
  {
    country: '洪都拉斯',
    countryCode: 'HN',
    email: 'notice',
    id: 'country-honduras',
  },
  {
    country: '匈牙利',
    countryCode: 'HU',
    email: 'opt-in',
    id: 'country-hungary',
  },
  {
    country: '冰島',
    countryCode: 'IS',
    email: 'opt-in',
    id: 'country-iceland',
  },
  { country: '印度', countryCode: 'IN', email: 'notice', id: 'country-india' },
  {
    country: '印度尼西亞',
    countryCode: 'ID',
    email: 'opt-out',
    id: 'country-indonesia',
  },
  { country: '伊朗', countryCode: 'IR', email: 'opt-out', id: 'country-iran' },
  {
    country: '伊拉克',
    countryCode: 'IQ',
    email: 'opt-out',
    id: 'country-iraq',
  },
  {
    country: '愛爾蘭',
    countryCode: 'IE',
    email: 'opt-in',
    id: 'country-ireland',
  },
  {
    country: '以色列',
    countryCode: 'IL',
    email: 'opt-in',
    id: 'country-israel',
  },
  {
    country: '意大利',
    countryCode: 'IT',
    email: 'opt-in',
    id: 'country-italy',
  },
  {
    country: '牙買加',
    countryCode: 'JM',
    email: 'notice',
    id: 'country-jamaica',
  },
  {
    country: '揚馬延',
    countryCode: 'XJ',
    email: 'opt-out',
    id: 'country-jan-mayen',
  },
  { country: '日本', countryCode: 'JP', email: 'opt-out', id: 'country-japan' },
  {
    country: '澤西',
    countryCode: 'JE',
    email: 'opt-out',
    id: 'country-jersey',
  },
  {
    country: '約旦',
    countryCode: 'JO',
    email: 'opt-out',
    id: 'country-jordan',
  },
  {
    country: '哈薩克',
    countryCode: 'KZ',
    email: 'opt-in',
    id: 'country-kazakhstan',
  },
  {
    country: '肯尼亞',
    countryCode: 'KE',
    email: 'opt-in',
    id: 'country-kenya',
  },
  {
    country: '基里巴斯',
    countryCode: 'KI',
    email: 'opt-out',
    id: 'country-kiribati',
  },
  { country: '韓國', countryCode: 'KR', email: 'opt-in', id: 'country-korea' },
  {
    country: '科索沃',
    countryCode: 'XK',
    email: 'opt-out',
    id: 'country-kosovo',
  },
  {
    country: '科威特',
    countryCode: 'KW',
    email: 'opt-in',
    id: 'country-kuwait',
  },
  { country: '老撾', countryCode: 'LA', email: 'opt-out', id: 'country-laos' },
  {
    country: '拉脫維亞',
    countryCode: 'LV',
    email: 'opt-in',
    id: 'country-latvia',
  },
  {
    country: '黎巴嫩',
    countryCode: 'LB',
    email: 'opt-out',
    id: 'country-lebanon',
  },
  {
    country: '萊索托',
    countryCode: 'LS',
    email: 'notice',
    id: 'country-lesotho',
  },
  {
    country: '利比里亞',
    countryCode: 'LR',
    email: 'opt-out',
    id: 'country-liberia',
  },
  {
    country: '利比亞',
    countryCode: 'LY',
    email: 'notice',
    id: 'country-libya',
  },
  {
    country: '列支敦士登',
    countryCode: 'LI',
    email: 'opt-in',
    id: 'country-liechtenstein',
  },
  {
    country: '立陶宛',
    countryCode: 'LT',
    email: 'opt-in',
    id: 'country-lithuania',
  },
  {
    country: '盧森堡',
    countryCode: 'LU',
    email: 'opt-in',
    id: 'country-luxembourg',
  },
  {
    country: '澳門特別行政區',
    countryCode: 'MO',
    email: 'notice',
    id: 'country-macao-sar',
  },
  {
    country: '馬達加斯加',
    countryCode: 'MG',
    email: 'opt-in',
    id: 'country-madagascar',
  },
  {
    country: '馬拉維',
    countryCode: 'MW',
    email: 'notice',
    id: 'country-malawi',
  },
  {
    country: '馬來西亞',
    countryCode: 'MY',
    email: 'opt-in',
    id: 'country-malaysia',
  },
  {
    country: '馬爾代夫',
    countryCode: 'MV',
    email: 'opt-out',
    id: 'country-maldives',
  },
  { country: '馬里', countryCode: 'ML', email: 'notice', id: 'country-mali' },
  {
    country: '馬耳他',
    countryCode: 'MT',
    email: 'opt-in',
    id: 'country-malta',
  },
  {
    country: '馬紹爾群島',
    countryCode: 'MH',
    email: 'opt-out',
    id: 'country-marshall-islands',
  },
  {
    country: '毛里塔里亞',
    countryCode: 'MR',
    email: 'notice',
    id: 'country-mauritania',
  },
  {
    country: '毛里裘斯',
    countryCode: 'MU',
    email: 'opt-in',
    id: 'country-mauritius',
  },
  {
    country: '馬約特',
    countryCode: 'YT',
    email: 'opt-out',
    id: 'country-mayotte',
  },
  {
    country: '墨西哥',
    countryCode: 'MX',
    email: 'opt-out',
    id: 'country-mexico',
  },
  {
    country: '密克羅尼西亞',
    countryCode: 'FM',
    email: 'opt-out',
    id: 'country-micronesia',
  },
  {
    country: '摩爾多瓦',
    countryCode: 'MD',
    email: 'opt-out',
    id: 'country-moldova',
  },
  {
    country: '摩納哥',
    countryCode: 'MC',
    email: 'opt-in',
    id: 'country-monaco',
  },
  {
    country: '蒙古',
    countryCode: 'MN',
    email: 'opt-in',
    id: 'country-mongolia',
  },
  {
    country: '黑山',
    countryCode: 'ME',
    email: 'opt-out',
    id: 'country-montenegro',
  },
  {
    country: '摩洛哥',
    countryCode: 'MA',
    email: 'opt-in',
    id: 'country-morocco',
  },
  {
    country: '莫桑比克',
    countryCode: 'MZ',
    email: 'opt-in',
    id: 'country-mozambique',
  },
  {
    country: '緬甸',
    countryCode: 'MM',
    email: 'opt-out',
    id: 'country-myanmar',
  },
  {
    country: '納米比亞',
    countryCode: 'NA',
    email: 'opt-out',
    id: 'country-namibia',
  },
  { country: '瑙魯', countryCode: 'NR', email: 'opt-out', id: 'country-nauru' },
  {
    country: '尼泊爾',
    countryCode: 'NP',
    email: 'opt-out',
    id: 'country-nepal',
  },
  {
    country: '荷蘭',
    countryCode: 'NL',
    email: 'opt-in',
    id: 'country-netherlands',
  },
  {
    country: '新喀里多尼亞',
    countryCode: 'NC',
    email: 'opt-out',
    id: 'country-new-caledonia',
  },
  {
    country: '新西蘭',
    countryCode: 'NZ',
    email: 'opt-in',
    id: 'country-new-zealand',
  },
  {
    country: '尼加拉瓜',
    countryCode: 'NI',
    email: 'opt-out',
    id: 'country-nicaragua',
  },
  {
    country: '尼日利亞',
    countryCode: 'NE',
    email: 'notice',
    id: 'country-niger',
  },
  {
    country: '尼日利亞',
    countryCode: 'NG',
    email: 'opt-out',
    id: 'country-nigeria',
  },
  {
    country: '紐威島',
    countryCode: 'NU',
    email: 'opt-out',
    id: 'country-niue',
  },
  {
    country: '北馬其頓',
    countryCode: 'MK',
    email: 'opt-out',
    id: 'country-north-macedonia',
  },
  { country: '挪威', countryCode: 'NO', email: 'opt-in', id: 'country-norway' },
  { country: '阿曼', countryCode: 'OM', email: 'notice', id: 'country-oman' },
  {
    country: '巴基斯坦',
    countryCode: 'PK',
    email: 'opt-in',
    id: 'country-pakistan',
  },
  { country: '帕勞', countryCode: 'PW', email: 'opt-out', id: 'country-palau' },
  {
    country: '巴勒斯坦民族權力機構',
    countryCode: 'PS',
    email: 'opt-out',
    id: 'country-palestinian-authority',
  },
  {
    country: '巴拿馬',
    countryCode: 'PA',
    email: 'opt-out',
    id: 'country-panama',
  },
  {
    country: '巴布亞新幾內亞',
    countryCode: 'PG',
    email: 'opt-out',
    id: 'country-papua-new-guinea',
  },
  {
    country: '巴拉圭',
    countryCode: 'PY',
    email: 'notice',
    id: 'country-paraguay',
  },
  { country: '秘魯', countryCode: 'PE', email: 'opt-in', id: 'country-peru' },
  {
    country: '菲律賓',
    countryCode: 'PH',
    email: 'opt-in',
    id: 'country-philippines',
  },
  {
    country: '皮特凱恩島',
    countryCode: 'PN',
    email: 'opt-out',
    id: 'country-pitcairn-islands',
  },
  { country: '波蘭', countryCode: 'PL', email: 'opt-in', id: 'country-poland' },
  {
    country: '葡萄牙',
    countryCode: 'PT',
    email: 'opt-in',
    id: 'country-portugal',
  },
  {
    country: '卡塔爾',
    countryCode: 'QA',
    email: 'notice',
    id: 'country-qatar',
  },
  {
    country: '剛果共和國',
    countryCode: 'CG',
    email: 'opt-out',
    id: 'country-republic-of-the-congo',
  },
  {
    country: '留尼汪島',
    countryCode: 'RE',
    email: 'opt-out',
    id: 'country-reunion',
  },
  {
    country: '羅馬尼亞',
    countryCode: 'RO',
    email: 'opt-in',
    id: 'country-romania',
  },
  {
    country: '盧旺達',
    countryCode: 'RW',
    email: 'notice',
    id: 'country-rwanda',
  },
  { country: '沙巴', countryCode: 'XS', email: 'opt-out', id: 'country-saba' },
  {
    country: '聖巴泰勒米',
    countryCode: 'BL',
    email: 'opt-out',
    id: 'country-saint-barthelemy',
  },
  {
    country: '聖赫勒拿、阿森松、特里斯坦達庫尼亞',
    countryCode: 'SH',
    email: 'opt-out',
    id: 'country-saint-helena-ascension-tristan-da-cunha',
  },
  {
    country: '聖基茨和尼維斯',
    countryCode: 'KN',
    email: 'opt-out',
    id: 'country-saint-kitts-and-nevis',
  },
  {
    country: '聖盧西亞',
    countryCode: 'LC',
    email: 'opt-out',
    id: 'country-saint-lucia',
  },
  {
    country: '聖皮埃爾島及密克隆島',
    countryCode: 'PM',
    email: 'opt-out',
    id: 'country-saint-pierre-and-miquelon',
  },
  {
    country: '聖文森特和格林納丁斯',
    countryCode: 'VC',
    email: 'opt-out',
    id: 'country-saint-vincent-and-the-grenadines',
  },
  {
    country: '薩摩亞',
    countryCode: 'WS',
    email: 'opt-out',
    id: 'country-samoa',
  },
  {
    country: '聖馬力諾',
    countryCode: 'SM',
    email: 'opt-out',
    id: 'country-san-marino',
  },
  {
    country: '聖多美及普林西比',
    countryCode: 'ST',
    email: 'opt-in',
    id: 'country-sao-tome-and-principe',
  },
  {
    country: '沙地阿拉伯',
    countryCode: 'SA',
    email: 'opt-in',
    id: 'country-saudi-arabia',
  },
  {
    country: '塞內加爾',
    countryCode: 'SN',
    email: 'opt-out',
    id: 'country-senegal',
  },
  {
    country: '塞爾維亞',
    countryCode: 'RS',
    email: 'opt-in',
    id: 'country-serbia',
  },
  {
    country: '塞舌爾',
    countryCode: 'SC',
    email: 'notice',
    id: 'country-seychelles',
  },
  {
    country: '塞拉利昂',
    countryCode: 'SL',
    email: 'opt-out',
    id: 'country-sierra-leone',
  },
  {
    country: '新加坡',
    countryCode: 'SG',
    email: 'opt-in',
    id: 'country-singapore',
  },
  {
    country: '聖佑達修斯',
    countryCode: 'XE',
    email: 'opt-out',
    id: 'country-sint-eustatius',
  },
  {
    country: '斯洛伐克',
    countryCode: 'SK',
    email: 'opt-in',
    id: 'country-slovakia',
  },
  {
    country: '斯洛文尼亞',
    countryCode: 'SI',
    email: 'opt-in',
    id: 'country-slovenia',
  },
  {
    country: '所羅門群島',
    countryCode: 'SB',
    email: 'opt-out',
    id: 'country-solomon-islands',
  },
  {
    country: '索馬里',
    countryCode: 'SO',
    email: 'opt-out',
    id: 'country-somalia',
  },
  {
    country: '南非',
    countryCode: 'ZA',
    email: 'opt-out',
    id: 'country-south-africa',
  },
  {
    country: '南佐治亞島與南桑威奇群島',
    countryCode: 'GS',
    email: 'opt-out',
    id: 'country-south-georgia-and-south-sandwich-islands',
  },
  {
    country: '南蘇丹',
    countryCode: 'SS',
    email: 'opt-out',
    id: 'country-south-sudan',
  },
  {
    country: '西班牙',
    countryCode: 'ES',
    email: 'opt-in',
    id: 'country-spain',
  },
  {
    country: '斯里蘭卡',
    countryCode: 'LK',
    email: 'opt-in',
    id: 'country-sri-lanka',
  },
  { country: '蘇丹', countryCode: 'SD', email: 'notice', id: 'country-sudan' },
  {
    country: '蘇里南',
    countryCode: 'SR',
    email: 'opt-out',
    id: 'country-suriname',
  },
  {
    country: '斯瓦爾巴特群島',
    countryCode: 'SJ',
    email: 'opt-out',
    id: 'country-svalbard',
  },
  { country: '瑞典', countryCode: 'SE', email: 'opt-in', id: 'country-sweden' },
  {
    country: '瑞士',
    countryCode: 'CH',
    email: 'opt-in',
    id: 'country-switzerland',
  },
  {
    country: '敘利亞',
    countryCode: 'SY',
    email: 'notice',
    id: 'country-syria',
  },
  {
    country: '塔吉克',
    countryCode: 'TJ',
    email: 'opt-in',
    id: 'country-tajikistan',
  },
  {
    country: '坦桑尼亞',
    countryCode: 'TZ',
    email: 'notice',
    id: 'country-tanzania',
  },
  {
    country: '泰國',
    countryCode: 'TH',
    email: 'opt-out',
    id: 'country-thailand',
  },
  {
    country: '東帝汶',
    countryCode: 'TL',
    email: 'opt-out',
    id: 'country-timor-leste',
  },
  { country: '多哥', countryCode: 'TG', email: 'notice', id: 'country-togo' },
  {
    country: '托克勞群島',
    countryCode: 'TK',
    email: 'opt-out',
    id: 'country-tokelau',
  },
  { country: '湯加', countryCode: 'TO', email: 'opt-out', id: 'country-tonga' },
  {
    country: '千里達和多巴哥',
    countryCode: 'TT',
    email: 'notice',
    id: 'country-trinidad-and-tobago',
  },
  {
    country: '突尼斯',
    countryCode: 'TN',
    email: 'opt-in',
    id: 'country-tunisia',
  },
  {
    country: '土耳其',
    countryCode: 'TR',
    email: 'double-opt-in',
    id: 'country-turkiye',
  },
  {
    country: '土庫曼',
    countryCode: 'TM',
    email: 'double-opt-in',
    id: 'country-turkmenistan',
  },
  {
    country: '特克斯和凱科斯群島',
    countryCode: 'TC',
    email: 'opt-out',
    id: 'country-turks-and-caicos-islands',
  },
  {
    country: '圖瓦盧',
    countryCode: 'TV',
    email: 'opt-out',
    id: 'country-tuvalu',
  },
  {
    country: '烏干達',
    countryCode: 'UG',
    email: 'notice',
    id: 'country-uganda',
  },
  {
    country: '烏克蘭',
    countryCode: 'UA',
    email: 'opt-in',
    id: 'country-ukraine',
  },
  {
    country: '阿拉伯聯合酋長國',
    countryCode: 'AE',
    email: 'opt-in',
    id: 'country-united-arab-emirates',
  },
  {
    country: '烏拉圭',
    countryCode: 'UY',
    email: 'opt-in',
    id: 'country-uruguay',
  },
  {
    country: '美國外島',
    countryCode: 'UM',
    email: 'opt-out',
    id: 'country-us-outlying-islands',
  },
  {
    country: '美屬維爾京群島',
    countryCode: 'VI',
    email: 'opt-out',
    id: 'country-us-virgin-islands',
  },
  { country: '美國', countryCode: 'US', email: 'notice', id: 'country-usa' },
  {
    country: '烏茲別克',
    countryCode: 'UZ',
    email: 'opt-in',
    id: 'country-uzbekistan',
  },
  {
    country: '委內瑞拉',
    countryCode: 'VE',
    email: 'opt-in',
    id: 'country-venezuela',
  },
  {
    country: '越南',
    countryCode: 'VN',
    email: 'opt-in',
    id: 'country-vietnam',
  },
  { country: '也門', countryCode: 'YE', email: 'notice', id: 'country-yemen' },
  {
    country: '贊比亞',
    countryCode: 'ZM',
    email: 'notice',
    id: 'country-zambia',
  },
  {
    country: '津巴布韋',
    countryCode: 'ZW',
    email: 'notice',
    id: 'country-zimbabwe',
  },
];

export const getAgeRange = (birthYear) => {
  if (!birthYear) return null;

  const currentYear = new Date().getFullYear();
  const age = currentYear - birthYear;

  if (age < 18) return ageRange[0]; // { id: 1, name: '18歲以下' }
  if (age <= 24) return ageRange[1]; // { id: 2, name: '18-24' }
  if (age <= 34) return ageRange[2]; // { id: 3, name: '25-34' }
  if (age <= 44) return ageRange[3]; // { id: 4, name: '35-44' }
  if (age <= 54) return ageRange[4]; // { id: 5, name: '45-54' }
  return ageRange[5]; // { id: 6, name: '55或以上' }
};

export const genderOptions = ['女性', '男性', '非二元或其它'];
export const getGenderName = (v) => {
  if (v == undefined || v == null || v === '') return null;
  if (v >= genderOptions.length) return null;
  return genderOptions[v] ?? null;
};